import { useEffect, useState } from 'react';

/**
 * 최하단 스크롤 시 목록 끝 번호 추가
 */
function useListScroll(extraHeight = 250) {
  /* state */
  // 목록 끝 번호
  const [end, setEnd] = useState(20);
  // 총 데이터 수
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const listener = () => {
      // 최하단 스크롤 시 목록 끝 번호 추가
      if (
        scrollY >= document.body.scrollHeight - innerHeight - extraHeight &&
        end < total
      ) {
        setEnd(end + 20);
      }
    };

    // 스크롤 시 이벤트 추가
    addEventListener('scroll', listener);

    return () => removeEventListener('scroll', listener);
  }, [end, total]);

  return {
    end,
    setEnd,
    total,
    setTotal
  };
}

export default useListScroll;
